module.exports = __webpack_public_path__ + "static/media/mindy_waving_physician 2.543dcc8b.png";